// Author YuJiaBei
// Date 2021-06-21 17:50:20

class EmOpcWatchEow {
constructor({
        id = null,
        eowIdOrigin = '',
        eowIdTarget = '',
        eounsNodeId = '',
        eocNodeId = '',
        eowPosition = '',
        eowEowcUniType = '',
        eowDuration = '',
        eowEnable = '',
        remark = ''}
= {}) {
    this.id = id;
    this.eowIdOrigin = eowIdOrigin;
    this.eowIdTarget = eowIdTarget;
    this.eounsNodeId = eounsNodeId;
    this.eocNodeId = eocNodeId;
    this.eowPosition = eowPosition;
    this.eowEowcUniType = eowEowcUniType;
    this.eowDuration = eowDuration;
    this.eowEnable = eowEnable;
    this.remark = remark;
}
}

function newEntity() {
return new EmOpcWatchEow();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.base.opcClient.emOpcWatchEow.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'eowIdOrigin',
        label: 'label.em.base.opcClient.emOpcWatchEow.grid.eowIdOrigin',
        sortable: true,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emOpcComputedEoc'
        }
        },
        {
        key: 'originEocName',
        label: 'label.em.base.opcClient.emOpcWatchEow.grid.originEocName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'originEocEowUniType',
        label: 'label.em.base.opcClient.emOpcWatchEow.grid.originEocEowUniType',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: ' AND ' },
                            { value: '2', text: ' OR ' }
            ]
        }
        },
        {
        key: 'originEocValueType',
        label: 'label.em.base.opcClient.emOpcWatchEow.grid.originEocValueType',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: 'String' },
                            { value: '2', text: 'Int' },
                            { value: '3', text: 'Float' }
            ]
        }
        },
        {
        key: 'eowPosition',
        label: 'label.em.base.opcClient.emOpcWatchEow.grid.eowPosition',
        sortable: true,
        form: {
        type: 'inputNumber'
        }
        },
        {
        key: 'eowIdTarget',
        label: 'label.em.base.opcClient.emOpcWatchEow.grid.eowIdTarget',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'targetEocName',
        label: 'label.em.base.opcClient.emOpcWatchEow.grid.targetEocName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'targetEocValueType',
        label: 'label.em.base.opcClient.emOpcWatchEow.grid.targetEocValueType',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: 'String' },
                            { value: '2', text: 'Int' },
                            { value: '3', text: 'Float' }
            ]
        }
        },
        {
        key: 'eounsNodeId',
        label: 'label.em.base.opcClient.emOpcWatchEow.grid.eounsNodeId',
        sortable: true,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emOpcUaNodeSubscriptionEouns'
        }
        },
        {
        key: 'eocNodeId',
        label: 'label.em.base.opcClient.emOpcWatchEow.grid.eocNodeId',
        sortable: true,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emOpcComputedEoc'
        }
        },
        {
        key: 'eowEowcUniType',
        label: 'label.em.base.opcClient.emOpcWatchEow.grid.eowEowcUniType',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: ' AND ' },
                            { value: '2', text: ' OR ' }
            ]
        }
        },
        {
        key: 'eowDuration',
        label: 'label.em.base.opcClient.emOpcWatchEow.grid.eowDuration',
        sortable: true,
        form: {
        type: 'inputNumber'
        }
        },
        {
        key: 'eowEnable',
        label: 'label.em.base.opcClient.emOpcWatchEow.grid.eowEnable',
        sortable: true,
        form: {
        type: 'boolean'
        }
        },
        {
        key: 'remark',
        label: 'label.em.base.opcClient.emOpcWatchEow.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    eowIdOriginFilter : "",
    eowIdTargetFilter : "",
    eounsNodeIdFilter : "",
    eocNodeIdFilter : "",
    eowDurationGteFilter : "",
    eowDurationLteFilter : "",
    eowEowcUniTypeFilter : "",
    eowPositionFilter : "",
    eowEnableFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'eowIdOriginFilter',
        label: 'label.em.base.opcClient.emOpcWatchEow.filter.eowIdOrigin',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emOpcComputedEoc'
            ,correspondingField: 'eocNodeId'
                }
        },
        {
        key: 'eowIdTargetFilter',
        label: 'label.em.base.opcClient.emOpcWatchEow.filter.eowIdTarget',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'eounsNodeIdFilter',
        label: 'label.em.base.opcClient.emOpcWatchEow.filter.eounsNodeId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emOpcUaNodeSubscriptionEouns'
            ,correspondingField: 'eouniNodeId'
            ,fieldsBindingByEntityModalSelected: '{"eowIdTarget":"eouniNodeId"}'
                }
        },
        {
        key: 'eocNodeIdFilter',
        label: 'label.em.base.opcClient.emOpcWatchEow.filter.eocNodeId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emOpcComputedEoc'
            ,correspondingField: 'eocNodeId'
            ,fieldsBindingByEntityModalSelected: '{"eowIdTarget":"eocNodeId"}'
                }
        },
        {
        key: 'eowDurationGteFilter',
        label: 'label.em.base.opcClient.emOpcWatchEow.filter.eowDurationGte',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'eowDurationLteFilter',
        label: 'label.em.base.opcClient.emOpcWatchEow.filter.eowDurationLte',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'eowEowcUniTypeFilter',
        label: 'label.em.base.opcClient.emOpcWatchEow.filter.eowEowcUniType',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: ' AND ' },
                { value: '2', text: ' OR ' }
            ]
        }
        },
        {
        key: 'eowPositionFilter',
        label: 'label.em.base.opcClient.emOpcWatchEow.filter.eowPosition',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'eowEnableFilter',
        label: 'label.em.base.opcClient.emOpcWatchEow.filter.eowEnable',
        disabled: false,
        form: {
        type: 'boolean'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'eowIdOrigin',
        label: 'label.em.base.opcClient.emOpcWatchEow.entity.eowIdOrigin',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emOpcComputedEoc'
            ,correspondingField: 'eocNodeId'
                }
        },
        {
        key: 'eowIdTarget',
        label: 'label.em.base.opcClient.emOpcWatchEow.entity.eowIdTarget',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'eounsNodeId',
        label: 'label.em.base.opcClient.emOpcWatchEow.entity.eounsNodeId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emOpcUaNodeSubscriptionEouns'
            ,correspondingField: 'eouniNodeId'
            ,fieldsBindingByEntityModalSelected: '{"eowIdTarget":"eouniNodeId"}'
                }
        },
        {
        key: 'eocNodeId',
        label: 'label.em.base.opcClient.emOpcWatchEow.entity.eocNodeId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emOpcComputedEoc'
            ,correspondingField: 'eocNodeId'
            ,fieldsBindingByEntityModalSelected: '{"eowIdTarget":"eocNodeId"}'
                }
        },
        {
        key: 'eowPosition',
        label: 'label.em.base.opcClient.emOpcWatchEow.entity.eowPosition',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'eowEowcUniType',
        label: 'label.em.base.opcClient.emOpcWatchEow.entity.eowEowcUniType',
        sortable: true,
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: ' AND ' },
                { value: '2', text: ' OR ' }
            ]
        }
        },
        {
        key: 'eowDuration',
        label: 'label.em.base.opcClient.emOpcWatchEow.entity.eowDuration',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'eowEnable',
        label: 'label.em.base.opcClient.emOpcWatchEow.entity.eowEnable',
        sortable: true,
        disabled: false,
        form: {
        type: 'boolean'
                }
        },
        {
        key: 'remark',
        label: 'label.em.base.opcClient.emOpcWatchEow.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmOpcWatchEow, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
